/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  Button,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Checkbox,
  FormGroup,
} from '@material-ui/core'
import '../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import { useFormElegibilidad } from '../../../context/ElegibilidadContext'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion9 from './Accordions/AccordionSec3/Pregunta9'
import NumberFormat from 'react-number-format'
import Table31 from './Tables/TablesSec3/Table31'
import Table33 from './Tables/TablesSec3/Table33'
import Table35 from './Tables/TablesSec3/Table35'
import Table36 from './Tables/TablesSec3/Table36'
import { saveElegibilityForm } from '../../../services/Elegibilidad/create'
import swal from 'sweetalert'
import SaveIcon from '@material-ui/icons/Save'
import ExitIcon from '@material-ui/icons/ExitToApp'
import { useEligibility } from '../../../context/EligibilityContext'
import Swal from 'sweetalert2'
import { getProductionAndLossByForm } from '../../../services/Elegibilidad/get'
import { LoadingButton } from '@mui/lab'

const ElegibilidadSec3 = (props) => {
  const { goToStep } = props
  const history = useHistory()
  const {
    PreEligibilityForm2,
    idElegibilityForm,
    setEligibilityForm,
    EligibilityForm,
  } = useFormElegibilidad()

  const idElegibilityNew = idElegibilityForm
  const [loading, setLoading] = useState(false)
  const [loadingSave, setLoadingSave] = useState(false)
  const [tableProductionandLoss, setTableProductionandLoss] = useState([])

  // Modales

  const [state, dispatch] = useEligibility()

  const EvaluationDataSchema = Yup.object().shape({
    ClimaticInformation: Yup.string()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    RiskCommittees: Yup.string()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    IdTechnicalTraining: Yup.string().required('Este campo es obligatorio'),
    IdTechnicalTrainingFrec: Yup.string().when('IdTechnicalTraining', {
      is: (IdTechnicalTraining) =>
        IdTechnicalTraining === 'CP' ||
        IdTechnicalTraining === 'AT' ||
        IdTechnicalTraining === 'AB',
      then: Yup.string().required('Este campo es obligatorio'),
    }),
    TechnicalTrainingManager: Yup.string()
      .max(200, 'Máximo 200 caracteres')
      .matches(
        /^[-\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .when('IdTechnicalTraining', {
        is: (IdTechnicalTraining) =>
          IdTechnicalTraining === 'CP' ||
          IdTechnicalTraining === 'AT' ||
          IdTechnicalTraining === 'AB',
        then: Yup.string().required('Este campo es obligatorio'),
      }),
    FrDetail: Yup.string()
      .max(80, 'Máximo 80 caracteres')
      .when('FrOther', {
        is: true,
        then: Yup.string().required('Este campo es obligatorio'),
      }),
    ReceivedCredits: Yup.number().when('FrCredits', {
      is: true,
      then: Yup.number().required('Este campo es obligatorio'),
    }),
    TtDetail: Yup.string()
      .max(80, 'Máximo 80 caracteres')
      .when('TtOther', {
        is: true,
        then: Yup.string().required('Este campo es obligatorio'),
      }),
    TechnicalTrainingEmplWomen: Yup.number()
      .max(
        EligibilityForm.WomenEmployees,
        'No deber pasar el total de mujeres empleadas',
      )
      .when('IdTechnicalTraining', {
        is: (IdTechnicalTraining) =>
          IdTechnicalTraining === 'CP' ||
          IdTechnicalTraining === 'AT' ||
          IdTechnicalTraining === 'AB',
        then: Yup.number().required('Este campo es obligatorio'),
      }),
    TechnicalTrainingEmplMen: Yup.number()
      .max(
        EligibilityForm.MenEmployees,
        'No deber pasar el total de hombres empleados',
      )
      .when('IdTechnicalTraining', {
        is: (IdTechnicalTraining) =>
          IdTechnicalTraining === 'CP' ||
          IdTechnicalTraining === 'AT' ||
          IdTechnicalTraining === 'AB',
        then: Yup.number().required('Este campo es obligatorio'),
      }),
    FoodSafety: Yup.boolean()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    FSHomesWomen: Yup.number().when('FoodSafety', {
      is: true,
      then: Yup.number()
        .required('Este campo es obligatorio')
        .typeError('Este campo es obligatorio'),
    }),
    FSHomesMen: Yup.number().when('FoodSafety', {
      is: true,
      then: Yup.number()
        .required('Este campo es obligatorio')
        .typeError('Este campo es obligatorio'),
    }),
    AccDrinkinWater: Yup.boolean()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    ProjectSites: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio')
      .test(
        'superior',
        'La cantidad de sitios debe ser mayor que 0',
        function (f) {
          const ref = 0
          return f > this.resolve(ref)
        },
      ),
    validTable31: Yup.boolean().oneOf(
      [true],
      'Los datos de esta tabla son obligatorios y el número de registros deben coincidir con el número de sitios',
    ),
    validTable33: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    validTable35: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    validTable391: Yup.boolean().when('ClimaticInformation', {
      is: true,
      then: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    }),
    validTable393: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validTable397: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    validTable398: Yup.boolean().oneOf([true], 'Tabla debe ser llenada'),
    // validTable399: Yup.boolean().oneOf(
    //   [true],
    //   'Tabla debe de tener un registro',
    // ),
  })

  const formik = useFormik({
    // enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      // IdElegibilityAnswer: idElegibilityForm,
      ClimateThreat: PreEligibilityForm2.ClimateThreat,
      NegativeImpact: PreEligibilityForm2.NegativeImpact,
      AccDrinkinWater: null,
      AdwRain: false,
      AdwGroundWater: false,
      AdwDrinkinWater: false,
      AdwVariousSources: false,
      FSHomesMen: 0,
      FSHomesWomen: 0,
      ClimaticInformation: null,
      ProjectSites: null,
      FoodSafety: null,
      TechnicalTrainingMen: 0,
      TechnicalTrainingWomen: 0,
      validTable31: false,
      validTable33: false,
      validTable35: false,
      validTable391: false,
      validTable393: false,
      // validTable397: false,
      validTable398: false,
      validTable399: false,
      RiskCommittees: null,
    },
    validationSchema: EvaluationDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }
  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const saveForm = async (values, borrador, exit) => {
    try {
      setLoading(true)
      setLoadingSave(true)
      const object = {
        // IdElegibilityAnswer: EligibilityForm.IdElegibilityAnswer,
        ...EligibilityForm,
        ...values,
      }
      const response = await saveElegibilityForm(object)
      if (response.Success) {
        saveValuesToContext(values)
        setLoading(false)
        setLoadingSave(false)

        if (borrador) {
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })
          if (exit) {
            history.push('/')
            setEligibilityForm([])
          }
        } else {
          next()
        }
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      setLoadingSave(false)
      console.log(error.message)
    }
  }

  const saveValuesToContext = () => {
    setEligibilityForm({
      ...EligibilityForm,
      isPotable: formik.values.isPotable,
      AccDrinkinWater: formik.values.AccDrinkinWater,
      AdwRain: formik.values.AdwRain,
      AdwGroundWater: formik.values.AdwGroundWater,
      AdwDrinkinWater: formik.values.AdwDrinkinWater,
      AdwVariousSources: formik.values.AdwVariousSources,
      FoodSafety: formik.values.FoodSafety,
      ProjectSites: formik.values.ProjectSites,
      FSHomesWomen: formik.values.FSHomesWomen,
      FSHomesMen: formik.values.FSHomesMen,
      ClimaticInformation: formik.values.ClimaticInformation,
      IdTechnicalTraining: formik.values.IdTechnicalTraining,
      IdTechnicalTrainingFrec: formik.values.IdTechnicalTrainingFrec,
      TechnicalTrainingWomen: formik.values.TechnicalTrainingWomen,
      TechnicalTrainingMen: formik.values.TechnicalTrainingMen,
      TechnicalTrainingEmplWomen: formik.values.TechnicalTrainingEmplWomen,
      TechnicalTrainingEmplMen: formik.values.TechnicalTrainingEmplMen,
      TechnicalTrainingManager: formik.values.TechnicalTrainingManager,
      TtEnvironmental: formik.values.TtEnvironmental,
      TtSocial: formik.values.TtSocial,
      TtFinance: formik.values.TtFinance,
      TtMarketAccess: formik.values.TtMarketAccess,
      TtInnovation: formik.values.TtInnovation,
      TtOther: formik.values.TtOther,
      TtDetail: formik.values.TtDetail,
      FrNotReceived: formik.values.FrNotReceived,
      FrOther: formik.values.FrOther,
      FrCredits: formik.values.FrCredits,
      FrDonations: formik.values.FrDonations,
      FrSubsidies: formik.values.FrSubsidies,
      FrDetail: formik.values.FrDetail,
      ReceivedCredits: formik.values.ReceivedCredits,
      RuWorkingCapital: formik.values.RuWorkingCapital,
      RuEquipmentPurchase: formik.values.RuEquipmentPurchase,
      RuPreinvestment: formik.values.RuPreinvestment,
      RuRealEstatePurchase: formik.values.RuRealEstatePurchase,
      RiskCommittees: formik.values.RiskCommittees,
    })
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 4 })
    goToStep(4)
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  // pregunta 7

  const handlePotableWater = (e) => {
    formik.setFieldValue('isPotable', e.target.value)

    if (e.target.value === 'si') {
      formik.setFieldValue('AccDrinkinWater', true)
    } else {
      formik.setFieldValue('AccDrinkinWater', false)
      formik.setFieldValue('AdwRain', false)
      formik.setFieldValue('AdwGroundWater', false)
      formik.setFieldValue('AdwDrinkinWater', false)
      formik.setFieldValue('AdwVariousSources', false)
    }
  }

  // TODO PARA LOS TIPOS DE AGUA
  const handleChangeWaterFont = (e) => {
    switch (e.target.value) {
      case 'AdwRain':
        if (e.target.checked === true) {
          formik.setFieldValue('AdwRain', true)
        } else {
          formik.setFieldValue('AdwRain', false)
        }
        break

      case 'AdwGroundWater':
        if (e.target.checked === true) {
          formik.setFieldValue('AdwGroundWater', true)
        } else {
          formik.setFieldValue('AdwGroundWater', false)
        }
        break
      case 'AdwDrinkinWater':
        if (e.target.checked === true) {
          formik.setFieldValue('AdwDrinkinWater', true)
        } else {
          formik.setFieldValue('AdwDrinkinWater', false)
        }
        break
      case 'AdwVariousSources':
        if (e.target.checked === true) {
          formik.setFieldValue('AdwVariousSources', true)
        } else {
          formik.setFieldValue('AdwVariousSources', false)
        }
        break
      default:
        formik.setValues({
          ...formik.values,
          AdwVariousSources: false,
          AdwDrinkinWater: false,
          AdwGroundWater: false,
          AdwRain: false,
        })

        break
    }
  }

  const handleFood = (e) => {
    if (e.target.value === 'si') {
      formik.setFieldValue('FoodSafety', true)
    } else {
      formik.setFieldValue('FoodSafety', false)
      formik.setFieldValue('FSHomesMen', 0)
      formik.setFieldValue('FSHomesWomen', 0)
    }
  }

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const exit = true
        saveForm(formik.values, true, exit)
      } else if (result.isDenied) {
        history.push('/')
        setEligibilityForm([])
      }
    })
  }

  // funcion para tabla 3.3
  // funcion para obtener la data de la tabla 3.3 y 3.5
  const getDataTableProductionAndLoss = async () => {
    try {
      const response = await getProductionAndLossByForm(idElegibilityForm)
      if (response.Success) {
        setTableProductionandLoss(response.Data)
        if (response.Data.length !== 0)
          formik.setFieldValue('validTable33', true)

        const resultValidate = response.Data.filter(
          (obj) => obj.RecentClimaticEvent === '',
        )
        if (resultValidate.length === 0)
          formik.setFieldValue('validTable35', true)
        else {
          formik.setFieldValue('validTable35', false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null
    ) {
      getDataTableProductionAndLoss()
      formik.setFieldValue(
        'IdElegibilityAnswer',
        EligibilityForm.IdElegibilityAnswer,
      )
    }
  }, [state.step])

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => saveForm(formik.values, true)}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>
      {/* Fin borrador */}
      <br></br>
      <form id="evaluation-data-form" onSubmit={formik.handleSubmit}>
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">
            EXPOSICIÓN A LOS IMPACTOS DEL CAMBIO CLIMÁTICO, VULNERABILIDAD Y
            CAPACIDADES DE ADAPTACIÓN
          </h1>
          <br />
        </Grid>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.ProjectSites || formik.errors.validTable31
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.1. Localización de la MIPYME / Miembros o Asociados
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Indique la ubicación de la MIPYME / miembros y asociados que se
                beneficiarán de las actividades del subproyecto.
              </label>
              <br></br>
              <br></br>
            </Grid>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Typography>
                  1. ¿En cuántos sitios se desarrollará el proyecto a financiar?
                  <a
                    data-tip="Si su proyecto se ejecutará en 2 o más sitios, indique la cantidad"
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="ProjectSites"
                    name="ProjectSites"
                    style={{ width: '100%' }}
                    error={!!formik.errors.ProjectSites}
                    variant="outlined"
                    customInput={TextField}
                    thousandSeparator={true}
                    allowLeadingZeros={false}
                    displayType={'input'}
                    inputProps={{ maxLength: 4 }}
                    decimalScale={0}
                    value={formik.values.ProjectSites}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'ProjectSites',
                        parseInt(e.target.value.replaceAll(',', '')),
                      )
                    }}
                    allowNegative={false}
                  />
                </FormControl>
                {formik.errors.ProjectSites ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.ProjectSites}
                  </div>
                ) : null}
              </Grid>
            </Grid>
            <Grid container spacing={1} className="input__container"></Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table31
                  idElegibilityForm={idElegibilityForm}
                  ProjectSites={formik.values.ProjectSites}
                  formik={formik}
                  EligibilityForm={EligibilityForm}
                ></Table31>
                {formik.errors.validTable31 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validTable31}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.2. Peligros climáticos para el ecosistema producción
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Peligros climáticos</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    id="ClimateThreat"
                    placeholder="Peligros Climáticos"
                    error={formik.errors.ClimateThreat}
                    customInput={TextField}
                    value={PreEligibilityForm2.ClimateThreat}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
            sx={formik.errors.validTable33 ? { border: '2px solid red' } : {}}
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.3. Producción y número de hectáreas expuestas a los efectos del
              cambio y a la variabilidad climática{' '}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Puede llenar 1 hasta 5 registros, según su caso.
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table33
                  getDataTableProductionAndLoss={getDataTableProductionAndLoss}
                  tableProductionandLoss={tableProductionandLoss}
                ></Table33>
                {formik.errors.validTable33 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validTable33}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.4. Descripción de los impactos negativos del peligro climático
              en la producción y el ecosistema
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Impactos negativos</label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Impactos Negativos"
                    error={formik.errors.NegativeImpact}
                    customInput={TextField}
                    value={PreEligibilityForm2.NegativeImpact}
                    disabled
                  ></textarea>
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
            sx={formik.errors.validTable35 ? { border: '2px solid red' } : {}}
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.5. Pérdida de producción debido a eventos relacionados con el
              clima
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Proporcione una estimación anual de la pérdida de producción
                resultante del evento climático más reciente dentro los últimos
                5 años: El tipo de producción de medida (p. Ej= Quintales por
                año / Toneladas por año / Número de ganado por año/ Ocupación
                por año). En la columna antecedentes, describa el evento
                climático más reciente.
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table35
                  tableProductionandLoss={tableProductionandLoss}
                  getDataTableProductionAndLoss={getDataTableProductionAndLoss}
                ></Table35>
                {formik.errors.validTable35 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validTable35}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.6. Pérdida de activos físicos debido a eventos relacionados con
              el clima
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Proporcione una estimación anual de daños o pérdidas a MIPYME o
                activos físicos privados, debido a eventos relacionado con el
                clima. (No obligatoria)
                <a
                  data-tip="Puede llenar 1 hasta 5 registros, según su caso. "
                  data-for="info6Pop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="info6Pop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </label>
              <br></br>
              <br></br>
            </Grid>
            {/* TABLE */}
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <Table36 idElegibilityForm={idElegibilityForm}></Table36>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
            sx={
              formik.errors.AccDrinkinWater ? { border: '2px solid red' } : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.7. Acceso al agua potable
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1. ¿Posee la MIPYME acceso al agua apta para consumo humano?{' '}
                  <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <RadioGroup
                    id="isNativeCommunity"
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    onChange={(e) => handlePotableWater(e)}
                    row
                  >
                    <FormControlLabel
                      value="si"
                      control={<Radio />}
                      label="Si"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  {formik.errors.AccDrinkinWater ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.AccDrinkinWater}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>

            {formik.values.AccDrinkinWater && (
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">2. Fuente de Agua:</label>
                </Grid>
                {/* TABLE */}
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="AdwRain"
                            onChange={(e) => handleChangeWaterFont(e)}
                          />
                        }
                        label="Lluvia"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="AdwGroundWater"
                            onChange={(e) => handleChangeWaterFont(e)}
                          />
                        }
                        label="Aguas Subterráneas"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="AdwDrinkinWater"
                            onChange={(e) => handleChangeWaterFont(e)}
                          />
                        }
                        label="Agua Potable"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            value="AdwVariousSources"
                            onChange={(e) => handleChangeWaterFont(e)}
                          />
                        }
                        label="Ríos, lagos, arroyos y manantiales naturales"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
            sx={
              formik.errors.FoodSafety ||
              formik.errors.FSHomesWomen ||
              formik.errors.FSHomesMen
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.8. Seguridad alimentaria
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  1. ¿En los hogares de socios y empleados/colaboradores de la
                  MIPYME corren el riesgo de no producir o no poder comprar /
                  obtener suficiente comida, debido a eventos relacionados con
                  el clima? <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="foodInfomation"
                    onChange={(e) => handleFood(e)}
                    row
                  >
                    <FormControlLabel
                      value="si"
                      control={<Radio />}
                      label="Si"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  {formik.errors.FoodSafety ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.FoodSafety}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>

            {formik.values.FoodSafety && (
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    2. ¿Cuántos de estos hogares corren el riesgo de no producir
                    o no poder comprar / obtener suficiente comida, debido a
                    eventos relacionados con el clima?{' '}
                  </label>
                  <br></br>
                </Grid>

                <Grid container spacing={1}>
                  {/* MUJERES */}
                  <Grid item xs={6} sm={6} md={6}>
                    <label className="responsiveLabel">
                      Hogares dirigidos por mujeres:
                      <a
                        data-tip="Se refiere a hogares en los que la jefe de
                  familia es una mujer (mujeres solteras,
                  viudas, separadas, con ausencia del
                  compañero)"
                        data-for="info82Pop"
                        style={{ cursor: 'pointer' }}
                      >
                        <ErrorOutlineIcon fontSize="small" />
                        <ReactTooltip
                          id="info82Pop"
                          effect="solid"
                          multiline={true}
                          type="dark"
                        />
                      </a>
                      <br></br>
                      <br></br>
                    </label>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="FSHomesWomen"
                        style={{ width: '100%' }}
                        error={!!formik.errors.FSHomesWomen}
                        customInput={TextField}
                        thousandSeparator={true}
                        variant="outlined"
                        allowLeadingZeros={false}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'FSHomesWomen',
                            parseInt(e.target.value.replaceAll(',', '')),
                          )
                        }}
                        value={formik.values.FSHomesWomen}
                        inputProps={{ maxLength: 3 }}
                        decimalScale={0}
                        allowNegative={false}
                      />
                      {formik.errors.FSHomesWomen ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.FSHomesWomen}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                  {/** HOMBRES */}
                  <Grid item xs={6} sm={6} md={6}>
                    <label className="responsiveLabel">
                      Hogares dirigidos por hombres:
                      <a
                        data-tip="Se refiere a hogares en los que el jefe de
                        familia es un hombre."
                        data-for="info821Pop"
                        style={{ cursor: 'pointer' }}
                      >
                        <ErrorOutlineIcon fontSize="small" />
                        <ReactTooltip
                          id="info821Pop"
                          effect="solid"
                          multiline={true}
                          type="dark"
                        />
                      </a>
                      <br></br>
                      <br></br>
                    </label>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="FSHomesMen"
                        style={{ width: '100%' }}
                        error={!!formik.errors.FSHomesMen}
                        customInput={TextField}
                        thousandSeparator={true}
                        variant="outlined"
                        allowLeadingZeros={false}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'FSHomesMen',
                            parseInt(e.target.value.replaceAll(',', '')),
                          )
                        }}
                        value={formik.values.FSHomesMen}
                        inputProps={{ maxLength: 3 }}
                        decimalScale={0}
                        allowNegative={false}
                      />
                      {formik.errors.FSHomesMen ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.FSHomesMen}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
            sx={
              formik.errors.ClimaticInformation ||
              formik.errors.validTable391 ||
              formik.errors.RiskCommittees ||
              formik.errors.IdTechnicalTraining ||
              formik.errors.IdTechnicalTrainingFrec ||
              formik.errors.totalMembers ||
              formik.errors.TechnicalTrainingMen ||
              formik.errors.totalEmployes ||
              formik.errors.TechnicalTrainingEmplWomen ||
              formik.errors.TechnicalTrainingEmplMen ||
              formik.errors.TechnicalTrainingManager ||
              formik.errors.validTable393 ||
              formik.errors.FrDetail ||
              formik.errors.ReceivedCredits ||
              formik.errors.validTable397 ||
              formik.errors.validTable397 ||
              formik.errors.validTable398
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3.9. Capacidades adaptativas
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Accordion9
                  idElegibilityNew={idElegibilityNew}
                  formik={formik}
                  tableProductionandLoss={tableProductionandLoss}
                ></Accordion9>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        {/** botones siguientes y anterior */}

        <Grid container spacing={1} className="button__container">
          <Grid container>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                // disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  <LoadingButton
                    loading={loadingSave}
                    type="button"
                    onClick={() => validateFormStatus()}
                    className="button__wizard button__next"
                    variant="outlined"
                  >
                    Siguiente
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSec3
